import { MoreView } from '@/features/more/MoreView'

export function MorePage() {
  return (
    <main>
      <MoreView />
    </main>
  )
}
